import * as React from 'react'

import { ISetUpNavigationRowProps } from './commonConstants'
import SetUpNavigationRowSimple from './SetUpNavigationRowSimple'
import SetUpNavigationRowWithSubSteps from './SetUpNavigationRowWithSubSteps'

const SetUpNavigationRow: React.FC<ISetUpNavigationRowProps> = ({
  projectSetUpPageStore,
  step,
  isShortVersion,
}) => {
  if (step.substeps) {
    return (
      <SetUpNavigationRowWithSubSteps
        step={step}
        projectSetUpPageStore={projectSetUpPageStore}
        isShortVersion={isShortVersion}
      />
    )
  }

  return (
    <SetUpNavigationRowSimple
      step={step}
      projectSetUpPageStore={projectSetUpPageStore}
      isShortVersion={isShortVersion}
    />
  )
}

export default SetUpNavigationRow
